import { MAPPINGS } from './_data/lookups.js';
export const generateIdentifier = (identifierName) => {
    const prefix = MAPPINGS.IdentifierNameToPrefix[identifierName];
    return (prefix + crypto.randomUUID());
};
